import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { newComics, comics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = [...comics].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">
            <Link to="/category/all" className="hover:text-primary-500 transition-colors">最新更新</Link>
          </h2>
          <p className="mt-1 text-sm text-foreground-500">每日更新，精彩内容不容错过</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
        {latestComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} showDescription />
        ))}
      </div>

      <div className="mt-8 p-5 bg-accent-100 rounded-lg">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
            <i className="ri-flashlight-line text-xl text-accent-600"></i>
          </div>
          <div>
            <h3 className="font-medium text-foreground-950">
              <Link to="/category/all" className="hover:text-accent-600 transition-colors">新作上架</Link>
            </h3>
            <p className="text-sm text-foreground-600 mt-1">
              每周精选新作上架，发现更多你喜欢的漫画作品
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              {newComics.map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="px-3 py-1 bg-background-50 rounded-full text-xs text-foreground-700 hover:text-primary-500 transition-colors border border-background-200/70 whitespace-nowrap cursor-pointer"
                >
                  {comic.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}